import { useEffect, useState, useCallback } from 'react';

import { getPostSaleReq } from '@/features/original-sale/api/sale.requests';
import type { GetPostSaleResponse } from '@/features/original-sale/types/sale.types';

export const useSaleSetupFormQuery = (postId?: string, shouldFetch: boolean = true) => {
  const [data, setData] = useState<GetPostSaleResponse | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const refetch = useCallback(async () => {
    if (!postId) {
      return;
    }

    setIsLoading(true);
    setError(null);

    try {
      const result = await getPostSaleReq(postId);
      setData(result);
    } catch (err) {
      const error = err instanceof Error ? err : new Error('Failed to load post sale data');
      setError(error);
      console.error('Failed to load post sale data:', err);
    } finally {
      setIsLoading(false);
    }
  }, [postId]);

  useEffect(() => {
    if (!postId || !shouldFetch) {
      return;
    }

    const loadPostSaleData = async () => {
      setIsLoading(true);
      setError(null);

      try {
        const result = await getPostSaleReq(postId);
        setData(result);
      } catch (err) {
        const error = err instanceof Error ? err : new Error('Failed to load post sale data');
        setError(error);
        console.error('Failed to load post sale data:', err);
      } finally {
        setIsLoading(false);
      }
    };

    loadPostSaleData();
  }, [postId, shouldFetch]);

  return {
    data,
    isLoading,
    error,
    refetch,
  };
};
